import { Box, Stack, styled } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { signOut } from '../../../../redux/auth';
import { AvatarGlobal } from '../../../UI/AvatarGlobal';
import { ButtonAcount, Icon, SupportingText, Text, TextSection } from './StyledComponentsMenu';

const AccountContainer = styled(Stack)({
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'row',
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '8px 8px',
  boxSizing: 'border-box',
});

const StackUser = styled(Stack)({
  flexDirection: 'row',
  gap: '12px',
  alignItems: 'center',
});

const BoxAvatar = styled(Box)({
  margin: '0px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
});

export const AcountItemMobile = ({ user, userNotOB }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleCloseUserMenu = async () => {
    await dispatch(signOut());
  };

  const handleNavigateProfile = () => {
    const destination = userNotOB ? '/myaccount' : '/completeregistration';
    navigate(destination);
  };

  const iconsLogout = '../../../assets/images/log-out.svg';

  return (
    <AccountContainer>
      <StackUser>
        <BoxAvatar onClick={handleNavigateProfile}>
          <AvatarGlobal width='40px' height='40px' />
        </BoxAvatar>

        <TextSection onClick={handleNavigateProfile} sx={{ cursor: 'pointer' }}>
          <Text>{`${user?.name} ${user?.['custom:paternal-surname']}`}</Text>
          <SupportingText>{user?.email}</SupportingText>
        </TextSection>
      </StackUser>
      <Icon>
        <ButtonAcount onClick={handleCloseUserMenu}>
          <img src={iconsLogout} alt='logout' />
        </ButtonAcount>
      </Icon>
    </AccountContainer>
  );
};
